import React , { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import './Ide.css';
import axios from 'axios';
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import AssistantIcon from '@mui/icons-material/Assistant';
import secret from './secret'
import { Link, useParams } from 'react-router-dom';
import Support from '../../components/support/Support';
import MonacoEditor from '@monaco-editor/react';
import {code} from './defaultCode';
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import {Typography, Breadcrumbs, Tooltip, CardContent, TextField, Fab, Modal, Fade, Backdrop, 
    Accordion, AccordionSummary, AccordionDetails, List, Divider} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LazyCKEditor from "../../components/shared/LazyCKEditor.jsx";
import { baseUrl } from '../../components/shared/baseUrl';
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators";
import {useSelector, useDispatch} from 'react-redux';

function Createmod() {
  return (
    <LazyCKEditor
      data="<p>Start writing here...</p>"
      onChange={(event, editor) => {
        console.log(editor.getData());
      }}
    />
  );
}

const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  }
  });
  


    export default function Ide(props){
    
        //const [code, setcode] = React.useState('');
        const theme = useTheme();
        const [mycode, setmycode] = React.useState(code['python']);
        var interval = null
        const [result, setresult] = React.useState('Submit to See Result');
        const [lang, setlang] = React.useState('python');
        const [input, setinput] = React.useState('');
        const [loading, setloading] = React.useState(true);
        const [userstate, setuserstate] = React.useState('');
        const [activity, setactivity] = React.useState([]);
        const [support, setsupport] = React.useState(true);
        const [expanded, setexpanded] = React.useState('');
        const [loadhint, setloadhint] = React.useState(false);
        const [myCount, setmyCount] = React.useState(10);
        const [myDecoCount, setmyDecoCount] = React.useState(10);
        const [finalCount, setfinalCount] = React.useState(19);
        const [Num, setNum] = React.useState(1);
        const user = useSelector(state => state.user)
        const dispatch = useDispatch();
        const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
        const classes = styles(theme);
        const { classId, sesId } = useParams();
        

        console.log(code)

        useEffect(() => {

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        const sessid = sesId;
        const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        console.log(user)
        var id = user.id;
        axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
        .then((response) => {
          console.log(response.data)
          if(response.data.activity2[0].coding.length!='0'){
            //console.log(response.data.activity1[0].coding[0].userCode)
            
            setmycode(response.data.activity2[0].coding[0].userCode)
        
          }
          
          setactivity(response.data.activity2[0])
          dispatch(
            upCount(0)
          )
          dispatch(
            finCount(19)
          )

          try{
            getData(sessid)
            interval = setInterval(() => {
                //console.log('Interval is working')
                getData(sessid);
                updateCount(user.count)
            }, 3000);
    
       
      } catch (error) {
          if (axios.isCancel(error)) {
            console.log("cancelled");
          } else {
            throw error;
          }
        }

          setloading(!loading)
          
          
        //   const ses = response.data.filter((session) => session.userId === id)
          
        })

    return() => {source.cancel();
    };
  }, [])

  const getData = (sessid) =>{
    const config = {
      headers: { Authorization: `Bearer ${user.token}` }
  };
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    //var num = Num+1
    //setNum(num)
    axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
        .then((response) =>{
          //console.log(response.data)
          const activity = response.data.activity2[0]

          //console.log(activity)
          setactivity(activity)
         

    })
  
}

    const onSubmitHandler = (event) => {
        event.preventDefault()
        
        alert("submit code")
        const mydata = {
            code:mycode,
            input: input,
            lang:'python'
        }
        console.log(mydata)
        console.log(input)
        axios.post(`${secret.url}code/submit`,mydata)
            .then(res=>{
                console.log(res.data)
                const data = res.data
                if(data.err){
                    // Error in user code
                    
                    setresult(data.error)
                }else{
                    
                    setresult(data.output)

                }

            })
            .catch(err=>{
                console.log(err)
            })
    }

    const Togglesupport = () =>{
        setsupport(!support)
        
        
      }

    const ToggleHint = () =>{
        
        setloadhint(!loadhint)
        
      }

    const onCodeChangeHandler = (newCode, e) => {
        console.log(e)
        code[lang]=newCode
        setmycode(newCode)
    }
    const onInputChangeHandler = (e) => {
        
        setinput(e.target.value)
    }

    const editorDidMount = (e) => {
        console.log("EDITOR MOUNTED")
    }


    const onLangSelectHandler = (e) => {
        const lang = e.target.value
        setlang(lang)
        setmycode(code[lang])
        // setcode(code[lang])
    }

    const options = {
        selectOnLineNumbers: true,
        renderIndentGuides: true,
        colorDecorators: true,
        cursorBlinking: "blink",
        autoClosingQuotes: "always",
        find: {
            autoFindInSelection: "always"
        },
        snippetSuggestions: "inline"
      };

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        
        setexpanded(isExpanded ? panel : false);
      };


    const saveScript =()=>{
    
        var scr = mycode;
        //var work = this.myWorkspace.current.innerHTML;
        alert(JSON.stringify('Saving...', null, 2));

        const myCode = {
            act:'activity2',
            coding: [{
                userCode:scr,
                levelofHints:'Basic'
            }]
            
        }
        const data=myCode;
        console.log(data)
    
        let url = `http://localhost:5000/pyinterpreter/profile/${sesId}`;
        axios.put(url, data)
            .then(response => {
                console.log(response.data)
            
            })
        .catch(errors => console.log(errors));
        

}

 const backdrop = {
    visible:{opacity: 1},
    hidden:{opacity: 0}
}

 const modal = {
    hidden:{
      y:"-100vh",
      opacity: 1
    },
    visible:{
      y: "200px",
      opacity:1,
      transition:{ delay: 0.5 }
    },
    exit:{
      y:"500vh",
      opacity: 1,
      transition:{ delay: 1 }

    },
  }
   const imageVariants = {
    animateOne:{
        x: [0, 500],
        //y: [0, -30],
        transition: {
            x:{
                repeat: finalCount,
                duration:3,
                ease:"easeOut"
            },
            // y:{
            //     yoyo: Infinity,
            //     duration:0.25,
            //     ease:"easeOut"
            // },
        }
    },
    animateTwo:{
      x: [0, 499],
      //y: [0, -30],
      transition: {
          x:{
              repeat: finalCount,
              duration:3,
              ease:"easeOut"
          },
          // y:{
          //     yoyo: Infinity,
          //     duration:0.25,
          //     ease:"easeOut"
          // },
      }
    }
  }

  const handleCountChange = (event) =>{
    var count = event.target.value
    
    setmyCount(count)
    //console.log(event.target.value)
  }

  const submitCount = () => {
    //console.log(myCount)
    dispatch(
      upCount(0)
    )
    
    var count = 2*myCount-1
    dispatch(
      finCount(count)
    )
    setfinalCount(count)
    cycleAnimation()
    //clearInterval(interval);


  }

  const updateCount = (count) =>{
    //console.log(count)
    
    setNum(count)

    if(count<=user.fcount)
    {
      count=count+1
      dispatch(
        upCount(count)
      )
    }
    
  }

        

        
        // console.log(this.state)
        return (
            <>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                        <Link color="inherit" to="/student/dashboard">
                            Dashboard
                        </Link>
                        <Link color="inherit" to={`/student/dashboard/viewstudentclass/${classId}`}>
                            <Typography color="textPrimary">Class VIII </Typography>
                        </Link>
                        <Link color="inherit" to={`/student/dashboard/viewstudentclass/${classId}/session/${sesId}/scenario`}>
                            <Typography color="textPrimary"> Scenario </Typography>
                        </Link>

                        <Link color="inherit" to={`/student/dashboard/viewstudentclass/${classId}/session/${sesId}/activity2`}>
                            <Typography color="textPrimary">Activity 2</Typography>
                        </Link>
                            <Typography color="textPrimary">Implementation</Typography>

                        </Breadcrumbs>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} >
                        <Typography variant="h5" className="header-message" align="center"> Implementation of the Algorithm </Typography>
                    </GridItem>
                    {loading!==true ?
                    <Card>
                    <CardContent>
                    <GridItem xs={12} sm={12} md={12}>
                        <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            >
                            <Typography className={classes.heading}>Problem Statement</Typography>
                            <Typography className={classes.secondaryHeading}>
                            This tab contains the problem statement
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                        <GridItem xs={12} sm={12} md={12}>
                                        {loading!==true?
                                            
                                            <CKEditor
                                            required
                                            editor={ ClassicEditor }
                                            disabled={true}
                                            data= "<p>You asked one of your workers to count the total number of aluminium sheets. After counting the aluminium sheets, the worker sent you a note which says:- 'The number of aluminium sheets is equal to the non-square numbers between the square of consecutive numbers 30 and 31.'</p><p>Number of aluminium sheets = Non-square numbers between 30<sup>2</sup> and 31<sup>2</sup></p><p><strong>Input: </strong>30</p><p><strong>Output: </strong>Total number of aluminium sheet=60</p><p><strong>Objective: </strong> Write an efficient algorithm to find the number of non-square numbers between square (n) and square (n+1).</p>" 
                                            />    
                                            :null}

                                        </GridItem>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            >
                            <Typography className={classes.heading}>Problem Formulation</Typography>
                            <Typography className={classes.secondaryHeading}>
                            This tab contains the problem Formulation steps
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                            <GridItem xs={12} sm={12} md={12} className={classes.paper}>
                                
                                <h3 id="simple-modal-description" align='center'>My Decomposition</h3>
                                            <CKEditor
                                              required
                                              editor={ ClassicEditor }
                                              disabled={true}
                                              data={activity.decomposition[0].userText}
                                                        
                                            />
                                <h3 id="simple-modal-description" align='center'>My Pattern</h3>
                                            <CKEditor
                                                required
                                                editor={ ClassicEditor }
                                                data={activity.pattern[0].userText}
                                                disabled={true}
                                                //config={custom_config}
                                            />
                                <h3 id="simple-modal-description" align='center'>My Abstraction</h3>
                                            <CKEditor
                                                required
                                                editor={ ClassicEditor }
                                                data={activity.abstraction[0].userText}
                                                disabled={true}
                                                //config={custom_config}
                                            />
                                <h3 id="simple-modal-description" align='center'>My Algorithm</h3>
                                            <CKEditor
                                                required
                                                editor={ ClassicEditor }
                                                data={activity.algorithm[0].userText}
                                                disabled={true}
                                                //config={custom_config}
                                            />
                                <h3 id="simple-modal-description" align='center'>My Analysis of the algorithm</h3>
                                            <CKEditor
                                                required
                                                editor={ ClassicEditor }
                                                data={activity.analysis[0].userText}
                                                disabled={true}
                                                //config={custom_config}
                                            />                                
                              </GridItem>
                            </AccordionDetails>
                        </Accordion>
                    </GridItem>
                    </CardContent>
                    </Card>:null}
{/*///////////////////////////////////////The simulation///////////////////////////////////////////////////////*/}
                
                    <GridItem xs={12} sm={12} md={3}>
                    </GridItem>
                {loading!==true ?
                    <GridItem xs={12} sm={12} md={8}>
                        <Card>
                        <CardHeader color="info">
                            <h4 className={classes.cardTitleWhite}>Collect Sheets</h4>
                        </CardHeader>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={8}>
                            
                            <motion.img 
                            variants={imageVariants}
                            animate={animation} 
                            //initial="hidden" animate="visible"
                            //animate="animateOne"
                            alt='Aluminium sheets' className="card-img-top" src={baseUrl+'assets/images/Aluminium.png'} 
                            style={{width: 100, height: 60, borderRadius: '10px',   border: "1px solid #6e8bff",
                            boxShadow: "0 0 2px 1px rgba(0, 140, 186, 0.5)"}}
                            />
                                <motion.div 
                                    variants={imageVariants}
                                    animate={animation} 
                                    //initial={{opacity: 1, transition:{ delay: 10 }}} 
                                    //animate={{opacity: 0, transition:{delay: 15+x}}}
                                    
                                    >
                                    1
                                </motion.div>

                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                            {Num}
                            <img alt='Collected sheets' className="card-img-top" src={baseUrl+'assets/images/multipleAlum.png'} 
                            style={{width: 200, height: 120, borderRadius: '10px',   border: "1px solid #6e8bff",
                            boxShadow: "0 0 2px 1px rgba(0, 140, 186, 0.5)"}}
                            />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12} className={classes.paper}>
                            <h3 id="simple-modal-description" align='center'>No. of sheets to deliver {finalCount+1}</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                            <TextField
                                //component={TextField}
                                type="text"
                                variant="outlined"
                                label="Enter your input"
                                name="countSheet"
                                value={myCount}
                                onChange={handleCountChange}
                                //validate={validateSimName}
                                //fullWidth= {true} 
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    //disabled={isSubmitting}
                                    onClick={submitCount}
                                >
                                    Submit
                            </Button>
                            </GridItem>
                        </GridContainer>
                                                            
                        </Card>
                    </GridItem>:null}

                    <GridItem xs={12} sm={12} md={3}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Fab color="secondary" aria-label="add" size="small" component="span" onClick={ToggleHint}>    
                                    <AssistantIcon />
                                </Fab>

                                {loadhint === true?loading!== true?
                                <div>
                                    <CardHeader color="success" align="center">
                                    <Typography variant="subtitle1" align="center" className={classes.cardTitleWhite}>Hints</Typography>
                                    </CardHeader>
                                    <List className={classes.messageArea}>
                                    <Accordion expanded={expanded === 'panel4'} onChange={handleAccordionChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography className={classes.heading}>Basic</Typography>
                                        {/* <Typography className={classes.secondaryHeading}>Hints </Typography> */}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        Count non-square numbers between squares of two small numbers.                              
                                    </AccordionDetails>
                                    </Accordion>        
                                    <Divider />
                                    <Accordion expanded={expanded === 'panel6'} onChange={handleAccordionChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography className={classes.heading}>Intermediate</Typography>
                                        {/* <Typography className={classes.secondaryHeading}>Hints </Typography> */}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        Check non squared number between 9 and 4 namely (5, 6, 7, 8). Similarly, in 9 and 16 (10, 11, 12, 13, 14, 15).                              
                                    </AccordionDetails>
                                    </Accordion>
                                    <Divider />
                                    <Accordion expanded={expanded === 'panel7'} onChange={handleAccordionChange('panel7')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                    >
                                        <Typography className={classes.heading}>Advanced</Typography>
                                        {/* <Typography className={classes.secondaryHeading}>Hints </Typography> */}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        Difference between square (2) and square (3) is 4, between square (3) and square (4) is 6.                             
                                    </AccordionDetails>

                                    </Accordion>
                                
                                    </List>
                                </div>
                            :null:null}
                           </GridItem>
                           <GridItem xs={12} sm={12} md={12}>
                            <Fab color="secondary" aria-label="add" size="small" component="span" onClick={Togglesupport}>    
                                <ContactSupportIcon />
                            </Fab>
                            {support == true?loading!== true?
                            <Support user = {sesId} act = 'activity2' classid = {classId}/>:null:null}
                           </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                    {loading!==true ?
                        <GridContainer> 
                            <GridItem xs={12} sm={12} md={12}>
                                <GridContainer> 
                                    <GridItem xs={12} sm={12} md={2}>
                                        <select id="lang" onChange={(e) => onLangSelectHandler(e)}>
                                            <option value="python">Python</option>
                                            <option value="cpp">C++</option>
                                            <option value="c">C</option>
                                            <option value="java">Java</option>
                                        </select>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <p className="lead d-block my-0">Write your code here</p>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <Button variant="contained" color="primary" onClick={onSubmitHandler}>Submit Code</Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            //disabled={isSubmitting}
                                            onClick={saveScript}
                                        >
                                            Save Code
                                        </Button>
                                    </GridItem>
                                </GridContainer>


                                <div type="text" id="code">
                                    <MonacoEditor
                                        width="600"
                                        height="500"
                                        language={lang}
                                        theme="vs-dark"
                                        value={mycode}
                                        options={options}
                                        onChange={onCodeChangeHandler}
                                        editorDidMount={editorDidMount}
                                    />
                                </div>
                            </GridItem>
                        </GridContainer>:null}
                        

                    </GridItem>
                    {loading!==true ?
                    <GridItem xs={12} sm={12} md={3}>
                        <GridContainer> 
                            
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader><h4>Output</h4></CardHeader>
                                                                
                                    <TextField id="result" multiline 
                                    value={result} disabled={true} label="Output" variant="outlined" />
                                </Card>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>

                                {mycode.includes('input()') || mycode.includes('scanf')?
                                <Card>
                                    <CardHeader><h4>Provide Input</h4></CardHeader>
                                    {/* <CardContent> */}
                                        
                                        {/* <textarea type="text" cols="20" id="input" value={this.state.input} onChange={this.onInputChangeHandler}>
                                        </textarea> */}
                                        
                                        <TextField id="input" multiline value={input} onChange={onInputChangeHandler} 
                                        label="Type input here" variant="outlined" />
                                    
                                    {/* </CardContent> */}
                                </Card>:null}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <Link to={`/student/dashboard/viewstudentclass/${classId}/session/${sesId}/activity3`}>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        //onClick={leaderSubmission}
                                      >
                                        Next Activity
                                      </Button>
                                </Link>
                            </GridItem>
                        </GridContainer>
                        
                    </GridItem>:null}
                </GridContainer>
            </>
        )
    
}
